import type { FC } from "react";

import { cn } from "@/lib/utils";

import { initialsOf } from "../utils";

export const CompanyMark: FC<{ name: string; className?: string }> = ({
  name,
  className
}) => (
  <span
    aria-hidden
    className={cn(
      "inline-flex size-8 shrink-0 items-center justify-center rounded-lg bg-fill-2 text-sm font-medium text-fg-2",
      className
    )}
  >
    {initialsOf(name)}
  </span>
);
